import i18next from 'i18next';

import { LANGUAGE_KEYS } from '~constants/languages';

i18next.addResources(LANGUAGE_KEYS.CHILE, 'BannerPapaPoints', {
  useThem: '¡Úsalos!',
  join: '¡Únete!',
  youHave: '¡Úsalos aquí!',
  accumulate: 'Empieza a acumular',
  description:
    'Inicia sesión o regístrate para acumular Papa Puntos y canjearlos por productos irresistibles',
  pj: 'Papa',
  points: 'Puntos'
});

i18next.addResources(LANGUAGE_KEYS.PORTUGAL, 'BannerPapaPoints', {
  useThem: 'Usa-os!',
  join: 'Aderir',
  youHave: 'Acumulaste',
  accumulate: 'Começa a acumular',
  description:
    'Adere já para ganhar Pontos que poderás trocar por deliciosas recompensas. Por cada 1 €, acumularás 10 Papa Pontos',
  papaPoints: '<span>Papa</span> Pontos',
  points: 'Pontos'
});

i18next.addResources(LANGUAGE_KEYS.SPAIN, 'BannerPapaPoints', {
  accumulate: 'Empieza a acumular',
  join: '¡Unirme!',
  youHave: '¡Úsalos aquí!',
  description:
    'Únete ya para conseguir Puntos que podrás canjear por deliciosas recompensas. Por cada 1€ acumularás 10 Papa Puntos.',
  papaPoints: '<span>Papa</span> Puntos'
});
